import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import pt from 'vuetify/es5/locale/pt'

Vue.use(Vuetify, {
  lang: {
    locales: { pt },
    current: 'pt'
  },
  theme: {
    primary: '#D12F24',
    secondary: '#A5251D',
    accent: '#FF5252',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    neutral: '#f5f5f5',
    lightgrey: '#eeeeee',
    grey: '#d5d5d5',
    dark: '#606060'
  }
})
